const initialState = {
  isOpen: false
};
function reducer(state, action) {
  if (action.type === "open") {
    return {
      ...state,
      isOpen: true
    };
  }
  if (action.type === "close") {
    return {
      ...initialState
    };
  }
  if (action.type === "toggle") {
    return {
      ...initialState,
      isOpen: !state.isOpen
    };
  }
  assertNever("Unexpected action: ", action);
}
function assertNever(message, x) {
  throw new Error(message + x);
}
export {
  initialState,
  reducer
};
//# sourceMappingURL=state3.js.map
